import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { greyBorderColor, lightBlue } from '../styles/colors';

var AudioIconProgressDiv = styled.div(function (props) {
  var style = {
    position: 'absolute',
    height: props.circleSize,
    width: props.circleSize
  };
  return style;
});

var STROKE_WIDTH = 2;

var getProgressCircleStyle = function getProgressCircleStyle(radius, progress) {
  var circumference = 2 * Math.PI * (radius + STROKE_WIDTH / 2);
  var strokeDashoffset = progress ? circumference - progress * circumference : circumference;
  var centerPoint = radius + STROKE_WIDTH;
  return {
    r: radius + STROKE_WIDTH / 2,
    cx: centerPoint,
    cy: centerPoint,
    strokeWidth: STROKE_WIDTH,
    fill: 'none',
    stroke: lightBlue,
    strokeDasharray: circumference + ' ' + circumference,
    strokeDashoffset: strokeDashoffset,
    transform: 'rotate(-90deg)',
    transformOrigin: centerPoint + 'px ' + centerPoint + 'px'
  };
};

//***************************************************************************************
export var AudioIconProgress = function (_PureComponent) {
  _inherits(AudioIconProgress, _PureComponent);

  function AudioIconProgress() {
    _classCallCheck(this, AudioIconProgress);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  AudioIconProgress.prototype.render = function render() {
    var radius = (this.props.circleSize - STROKE_WIDTH * 2) / 2;
    var progressCircleStyle = getProgressCircleStyle(radius, this.props.progress);

    return React.createElement(
      AudioIconProgressDiv,
      { circleSize: this.props.circleSize },
      React.createElement(
        'svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          preserveAspectRatio: 'none',
          viewBox: '0 0 ' + this.props.circleSize + ' ' + this.props.circleSize
        },
        React.createElement('circle', { style: progressCircleStyle })
      )
    );
  };

  return AudioIconProgress;
}(PureComponent);
AudioIconProgress.propTypes = {
  circleSize: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired
};